import {RegistrationProgressStepView} from '@app/features/registration/interfaces';

export const REGISTRATION_BASE_ROUTE = '/registration';

export const REGISTRATION_STEP_ROUTES = [
  'basic-information',
  'personal-information',
  'legal-information',
  'address-information',
] as const;

export type RegistrationStepRoute = (typeof REGISTRATION_STEP_ROUTES)[number];

export interface RegistrationStepDefinition {
  route: RegistrationStepRoute;
  title: string;
  icon: string;
}

export const REGISTRATION_ROUTE_SECTION_STEP: Record<RegistrationStepRoute, number> = {
  'basic-information': 1,
  'personal-information': 2,
  'legal-information': 3,
  'address-information': 4,
};

export const REGISTRATION_STEP_DEFINITIONS: Record<
  RegistrationStepRoute,
  RegistrationStepDefinition
> = {
  'basic-information': {
    route: 'basic-information',
    title: 'اطلاعات اولیه',
    icon: 'ic-ui-essentional-info-circle',
  },
  'personal-information': {
    route: 'personal-information',
    title: 'مشخصات فردی',
    icon: 'ic-users-user',
  },
  'legal-information': {
    route: 'legal-information',
    title: 'اطلاعات حقوقی',
    icon: 'ic-notes-documents',
  },
  'address-information': {
    route: 'address-information',
    title: 'آدرس و تماس',
    icon: 'ic-ui-essentional-home-smile-angle',
  },
};

const STEP_ORDINAL_LABELS = ['اول', 'دوم', 'سوم', 'چهارم'] as const;

export function getRegistrationStepRoutes(isLegalEntity: boolean): RegistrationStepRoute[] {
  if (isLegalEntity) {
    return [
      'basic-information',
      'personal-information',
      'legal-information',
      'address-information',
    ];
  }

  return ['basic-information', 'personal-information', 'address-information'];
}

export function getDefaultStepDescription(stepIndex: number): string {
  return `مرحله ${STEP_ORDINAL_LABELS[stepIndex] ?? String(stepIndex + 1)}`;
}

export const REGISTRATION_PENDING_BY_ADMIN_PROGRESS_STEP: RegistrationProgressStepView = {
  route: 'basic-information',
  title: 'احراز هویت',
  icon: 'ic-users-user-id',
  status: 'pending',
  description: {
    text: 'در حال بررسی',
    icon: 'ic-time-hourglass',
  },
  isActive: true,
  isNavigable: false,
};

export const REGISTRATION_FINISHED_PROGRESS_STEP: RegistrationProgressStepView = {
  route: 'basic-information',
  title: 'احراز هویت',
  icon: 'ic-users-user-id',
  status: 'done',
  description: {
    text: 'تکمیل شد',
    icon: 'ic-ui-essentional-check-circle',
  },
  isActive: false,
  isNavigable: false,
};
